import React, { createContext, useContext, useState } from 'react';

const FilterContext = createContext();

export const FilterProvider = ({ children }) => {
  const [filterValue, setFilterValue] = useState(null);

  const updateFilterValue = (value) => {
    setFilterValue(value);
  };

  return (
    <FilterContext.Provider value={{ filterValue: filterValue, updateFilterValue: updateFilterValue }}>
      {children}
    </FilterContext.Provider>
  );
};

export const useFilterContext = () => useContext(FilterContext);
